import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.OUT.enumeration<
  graphql.schema.ReportCellStyle,
  ents.extra.common.Report.Cell.Style
>({
  [graphql.schema.ReportCellStyle.ColumnHeader]:
    ents.extra.common.Report.Cell.Style.ColumnHeader,
  [graphql.schema.ReportCellStyle.Divider]:
    ents.extra.common.Report.Cell.Style.Divider,
  [graphql.schema.ReportCellStyle.GrandTotal]:
    ents.extra.common.Report.Cell.Style.GrandTotal,
  [graphql.schema.ReportCellStyle.Label]:
    ents.extra.common.Report.Cell.Style.Label,
  [graphql.schema.ReportCellStyle.ReportHeader]:
    ents.extra.common.Report.Cell.Style.ReportHeader,
  [graphql.schema.ReportCellStyle.SectionHeader]:
    ents.extra.common.Report.Cell.Style.SectionHeader,
  [graphql.schema.ReportCellStyle.SubsectionHeader]:
    ents.extra.common.Report.Cell.Style.SubsectionHeader,
  [graphql.schema.ReportCellStyle.Subtotal]:
    ents.extra.common.Report.Cell.Style.Subtotal,
})
